module.exports = __webpack_public_path__ + "img/_attach_white.1779c2a5.svg";